import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class McsAppComponent implements OnInit {
  title = 'ethervox-mcs-ui';

  constructor() {}

  ngOnInit(): void {}
}
